<template>
  <a
    tabindex="0"
    role="button"
    data-toggle="popover"
    data-container="body"
    :data-content="`${content}`"
    data-trigger="focus"
    data-html="true"
  >
    <span style="color: #0073ad;" class="fas fa-info-circle"></span>
  </a>
</template>
<script>
  export default {
    name: 'Popover',

    props: {
      content: {
        type: String,
        required: true,
      },
    },

    mounted() {
      this.$nextTick(() => {
        $(this.$el).popover({
          html: true,
          placement: 'auto',
        });
      });
    },

    activated() {
      $(this.$el).popover({
        html: true,
        placement: 'auto',
      });
    },

    destroyed() {
      $(this.$el).popover('destroy');
    },

    deactivated() {
      $(this.$el).popover('destroy');
    },
  };
</script>
